import '../App.css';
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMutation, useApolloClient } from '@apollo/client';
import { useQuery, gql } from '@apollo/client';
import useValidator from '../Validator';
import { LOGIN_MUTATION } from '../graphqlDefs/authentication/mutations';
import { PAGES } from '../constants/Pages';
import { Magic } from 'magic-sdk';
import { OAuthExtension } from '@magic-ext/oauth';
import { Button } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import SnackToast from './SnackToast';
import { MESSAGE } from '../constants/Message';

function Login(props) {
  const client = useApolloClient();
  const magic = new Magic(`${process.env.REACT_APP_MAGIC_LINK}` || '', {
    extensions: [new OAuthExtension()],
  });
  const [validator, setValidator] = useValidator();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginStatus, setLoginStatus] = useState('');
  const [activeLoader, setActiveLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  let loginFormValidation = {
    email: validator.message('email', email, 'required|email'),
    password: validator.message('password', password, 'required'),
  };
  const [snackAlert, setSnackAlert] = useState({
    popOn: false,
    customAlertMessage: MESSAGE.ENG.INVALID_CREDENTIALS,
    severity: '',
  });
  
  let redirect_Page = () => {
    let tID = setTimeout(function () {
      window.location.href = `/${PAGES.UPLOADERSCREEN}`;
      window.clearTimeout(tID); // clear time out.
    }, 1000);
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const [login, { data, error }] = useMutation(LOGIN_MUTATION);
  const handleLogin = async (elm) => {
    elm.preventDefault();
    setActiveLoader(true);
    if (validator.allValid()) {
      try {
        const response = await login({ variables: { email, password } });
        const tokenValue = response.data.login.token;
        if (tokenValue !== '') {
          localStorage.setItem('TOKEN', tokenValue);
          localStorage.setItem('ISLOGIN', 'true');
          localStorage.setItem('EMAIL', email);
          setActiveLoader(false);
          setLoginStatus('successMsg');
          setSnackAlert({ "popOn": true,"customAlertMessage": MESSAGE.ENG.VALID_CREDENTIALS,"severity": "success" });
          redirect_Page();
        } else {
          localStorage.setItem('ISLOGIN', 'false');
          setActiveLoader(false);
          setLoginStatus('failureMsg');
          setSnackAlert({ "popOn": true,"customAlertMessage": MESSAGE.ENG.INVALID_CREDENTIALS,"severity": "error" });
        }
      } catch (error) {
        console.error('Login error:', error);
        if (error) {
          const errorMessage = error.message;
          if (errorMessage === 'WRONG_CREDENTIALS') {
            localStorage.setItem('ISLOGIN', 'false');
            setLoginStatus('failureMsg');
            setSnackAlert({ "popOn": true,"customAlertMessage": MESSAGE.ENG.INVALID_CREDENTIALS,"severity": "error" });
          } else {
            setLoginStatus('failureMsg');
            setSnackAlert({ "popOn": true,"customAlertMessage": MESSAGE.ENG.INVALID_CREDENTIALS,"severity": "error" });
          }
        } else {
          setLoginStatus('failureMsg');
          setSnackAlert({ "popOn": true,"customAlertMessage": MESSAGE.ENG.INVALID_CREDENTIALS,"severity": "error" });
        }
        setActiveLoader(false);
      }
    } else {
      setActiveLoader(false);
      setValidator(true);
    }
    return false;
  };

  const isLogin = localStorage.getItem('ISLOGIN');
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.status) {
      if (params.status) {
        setLoginStatus('failureMsg');
      }
    }
  }, [location.search, props.setLoginStatus]);

  useEffect(() => {
    if (isLogin === 'true') {
      // If already login then redirect to first screen i.e.
      navigate('/UploaderScreen');
    }
  }, [isLogin,navigate]);

  if (isLogin === 'true') {
    return null;
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent form submission
      handleLogin(e);
    }
  };
  const handleClose = (e) => {
    setSnackAlert({ "popOn": false });
  };
  return (
    <>
      <body className='login-bg'>
        <div className='headerBg'>
          <div className='logoBox'>
            <svg width='36' height='36' viewBox='0 0 61 104'>
              <g id='_03' data-name='03'>
                <g id='Logo-harold' transform='translate(0 0)'>
                  <g id='Group-2' transform='translate(0)'>
                    <g id='Icon-Harold'>
                      <path
                        id='Path'
                        d='M59.712,85.2l-57.264,18.7A1.868,1.868,0,0,1,0,102.131V47.425a1.246,
                        1.246,0,0,1,.814-1.169L58.142,25.077a1.246,1.246,0,0,1,1.677,1.143L61,
                        83.39A1.869,1.869,0,0,1,59.712,85.2Z'
                        transform='translate(0 0)'
                        fill='#8ecbff'
                      ></path>
                      <path
                        id='Path-2'
                        data-name='Path'
                        d='M2,63.37,58.465,84.877a1.87,1.87,0,0,0,2.411-1.072A1.851,1.851,0,
                        0,0,61,83.141V23.92a1.859,1.859,0,0,0-1.193-1.733L2.541.126A1.87,1.87,
                        0,0,0,.126,1.188,1.851,1.851,0,0,0,0,1.859V60.477A3.1,3.1,0,0,0,2,63.37Z'
                        transform='translate(0 0)'
                        fill='#4d30ef'
                      ></path>
                      <g id='Group' transform='translate(0 22.069)'>
                        <path
                          id='Path-3'
                          data-name='Path'
                          d='M60.836,62.047V1.472A1.242,1.242,0,0,0,60.043.314L59.412.069,
                          1.611,21.76A2.485,2.485,0,0,0,0,24.087V38.918a2.485,2.485,0,0,0,
                          1.594,2.32L59.088,63.317l.909-.3A1.242,1.242,0,0,0,60.836,62.047Z'
                          transform='translate(0 -0.069)'
                          fill='#3a0d98'
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
        {/* <div
          className={
            activeLoader === true ? 'CommetsLoader active' : 'CommetsLoader'
          }
        ></div> */}
        <div className='LoginSection'>
          <div className='LoginWrap'>
            <div className='LoginInfo'>
              <h3> Log in </h3>
              <p>
                Optimize and control your sourcing of recycled materials
                conveniently.
              </p>
            </div>
            <div className='LoginForm'>
              <form className='formDesign' id='form1' onKeyDown={handleKeyDown}>
                <div className='FormInputBox'>
                  <div className={`${loginFormValidation.email === undefined ? 'FormInput':'FormInput validErr'}`}>
                    <label htmlFor='email'>Email</label>
                    <input
                      aria-invalid='false'
                      name='email'
                      type='email'
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {<p className='mt1' style={{color: 'red'}}>{loginFormValidation.email}</p>}
                  </div>
                  <div className={`${loginFormValidation.password === undefined ? 'FormInput':'FormInput validErr'}`}>
                    <div className='password-eye-view'>
                      <label htmlFor='password'>Password</label>
                      <input
                        name='password'
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <IconButton
                        aria-label="visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        className='eye-view'
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </div>  
                    {<p className='mt1' style={{color: 'red'}}>{loginFormValidation.password}</p>}
                  </div>
                </div>
              </form>
            </div>
            <SnackToast
              popOn={snackAlert.popOn}
              message={snackAlert.customAlertMessage}
              severity={snackAlert.severity}
              handleClose={handleClose}
            />
            {isLogin === null ? (
              <></>
            ) : (
              <>
                {loginStatus === 'successMsg' ? (
                  // <div className={'loginAfterMsg successMsg'}>
                  //   <span> Login Success </span>
                  // </div>
                  <></>
                ) : (
                  <>
                    {loginStatus === 'failureMsg' ? (
                      // <div className={'loginAfterMsg failureMsg'}>
                      //   <span> Invalid Credentials </span>
                      // </div>
                      <></>
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </>
            )}
            <div className='LoginButtomSection'>
              <LoadingButton
                type='submit'
                className={activeLoader ? undefined : 'login-btn-rglr'}
                variant='outlined'
                data-test-id='signin'
                onClick={handleLogin}
                loading={activeLoader ? 'loading' : undefined}
                style={{ cursor: 'pointer' }}
              >
                Log in
              </LoadingButton>
              <Button
                variant='contained'
                data-test-id='signinMicrosoft'
                className='login-btn-sso'
                onClick={async () => {
                  await magic.oauth.loginWithRedirect({
                    provider: 'microsoft',
                    redirectURI: `${process.env.REACT_APP_DATA_UPLOADER_URL}/${PAGES.AUTHENTICATION_TOKEN}`,
                  });
                }}
              >
                Login with Microsoft
              </Button>
              <Button
                variant='contained'
                data-test-id='signin'
                className='login-btn-sso'
                onClick={async () => {
                  await magic.oauth.loginWithRedirect({
                    provider: 'google',
                    redirectURI: `${process.env.REACT_APP_DATA_UPLOADER_URL}/${PAGES.AUTHENTICATION_TOKEN}`,
                  });
                }}
              >
                Login with Google
              </Button>
            </div>
          </div>
        </div>
      </body>
    </>
  );
}

export default Login;
